<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="stockSelected"
    :clearable="!unclearable"
    :items="stocksItems"
    :loading="stockLoading"
    :search-input.sync="stockSearch"
    item-text="Description"
    item-value="id"
    item-disabled="disabled"
    :label="noLabel ? '' : label ? label : $t('Stock.ObjectName')"
    return-object
    :single-line="singleLine"
    :dense="dense"
    :hide-details="hideDetails"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
    @change="$emit('change');"
  ></v-autocomplete>
</template>

<script>
import Stocks from "@/api/stocks";
import i18n from "@/i18n";

export default {
  name: "SearcherStock",

  props: {
    value: Object,
    stockDistrict: Object,
    stockDistricts: Array,
    noLabel: Boolean,
    label: String,
    singleLine: Boolean,
    dense: Boolean,
    hideDetails: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    allStocks: Boolean, // 此项为true返回所有仓库，否则过滤只显示已启用仓库
    stockTypes: Array,
    showVirtualStock: Boolean, // 此选项为true时在select中追加虚拟仓库标记
    removeStockIds: Array, // 此项为排除仓库选择的参数
    wmsSetting: Array,
    productionAttribute: Array, // 此项为仓库生产属性默认不过滤
    identityType: Array,
  },

  computed: {
    stocksItems() {
      var stocks;
      if (this.stockDistrict) {
        stocks = this.stocks.filter(
          (stock) => stock.stock_district_code == this.stockDistrict.code
        );
      } else {
        stocks = this.stocks;
      }
      if (this.stockDistricts && this.stockDistricts.length > 0) {
        stocks = this.stocks.filter((e) =>
          this.stockDistricts.find((v) => v.code == e.stock_district_code)
        );
      } else {
        stocks = this.stocks;
      }
      return stocks.map((stock) => {
        let Description = '';
        if (this.showVirtualStock && stock.type == 1) {
          Description = stock.code + " / " + stock.name + " " + i18n.t("Global.brackets", [i18n.t("Stock.type.v_auto")]);
        } else {
          Description = stock.code + " / " + stock.name;
        }
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.id == stock.id
            )
          : false;
        return Object.assign({}, stock, { Description, disabled });
      });
    },
  },

  data: () => ({
    stocks: [],
    stockLoading: false,
    stockSearch: "",
    stockSelected: null,
  }),

  mounted() {
    this.stockLoading = true;
    let data = this.allStocks ? {} : { types: this.stockTypes, status: 1, identity_type: this.identityType }
    if (this.removeStockIds) {
      data.remove_stock_ids = this.removeStockIds
    }
    if (this.productionAttribute) {
      data.production_attribute = this.productionAttribute
    }
    if (this.wmsSetting) {
      data.wms_setting = this.wmsSetting
    }
    Stocks.fetchAllForSelect(data)
      .then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stocks = response.data.stocks;
            if (this.$route.query.stock_id) {
              let result = this.stocks.filter((v) => {
                return v.id == this.$route.query.stock_id;
              });
              this.stockSelected = result[0];
            } else {
              if (!this.value && this.unclearable) {
                this.stockSelected = this.stocks[0];
              }
            }
          }
          this.stockLoading = false;
        }.bind(this)
      )
      .catch(
        function () {
          this.stockLoading = false;
        }.bind(this)
      );
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.unclearable && !this.value && this.stocks) {
          this.stockSelected = this.stocks[0];
        } else {
          this.stockSelected = this.value;
        }
      },
    },

    stockSelected: {
      handler() {
        this.$emit("input", this.stockSelected);
      },
    },
  },
};
</script>